/**
 * 사용자 배열에서 Manager와 Worker 수를 계산합니다.
 * @param users - 사용자 배열 (role 속성을 가진 객체 또는 user.role을 가진 객체)
 * @param getRole - 사용자 객체에서 role을 추출하는 함수
 */
export const calculateUserCount = <T>(
  users: T[] | null | undefined,
  getRole: (user: T) => string | undefined,
): { manager: number; worker: number } => {
  return (
    users?.reduce(
      (acc, cur) => {
        const role = getRole(cur);
        const isWorker = role === 'Worker';

        return {
          manager: acc.manager + (isWorker ? 0 : 1),
          worker: acc.worker + (isWorker ? 1 : 0),
        };
      },
      { manager: 0, worker: 0 },
    ) ?? { manager: 0, worker: 0 }
  );
};
